import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import './home.css'; 
import '../common/common.css'; 

import { postLogin, postPw, CMS_BASE_URL } from '../../redux/action';

import loginBanner from '../../images/loginBanner.png';

class Login extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	title: "Login",
	    	email: "",
	    	password: "",
	    	errorReset: false,
	    	errorEmail: false,
	    	errorPw: false,
	    	errorGeneral: false,
	    	errorPending: false
	    };
    }

	componentWillMount() {

	}

	resetPassword() {

		if (this.state.email == "") {
			this.setState({ errorEmail: true })
			return
		} else {
			this.setState({ errorEmail: false })
		}

		postPw({ "email": this.state.email }).then(res => {

			if (res.data.code == 402) {
				this.setState({ errorGeneral: true, errorPending: false, errorReset: false })
			}

			if (res.data.code == 201) {
				this.setState({ errorPending: true, errorReset: false, errorGeneral: false })
			}
			if (res.data.code == 200) {
				this.setState({ errorReset: true, errorGeneral: false, errorReset: false })
			}

		}, this)

	}

	validateLogin() {
		if (this.state.email == "") {
			this.setState({ errorEmail: true })
			return
		} else {
			this.setState({ errorEmail: false })
		}

		if (this.state.password == "") {
			this.setState({ errorPw: true })
			return
		} else {
			this.setState({ errorPw: false })
		}

		this.postLogin();
	}

	postLogin() {
		postLogin({ "email": this.state.email, "password": this.state.password }).then(res => {
					if (res.data.code == 200) {
						window.localStorage.setItem("token",res.data.userToken);
						window.location.href = "/";
					}

					if (res.data.code == 201) {
						this.setState({ errorPending: true });
					}

					if (res.data.code == 402) {
						this.setState({ errorGeneral: true });
					}
		}, this)
	}


	render() {

		return(
			<div className="geContainer">
				<Header urlKey={this.props.urlKey} />
				<div className="mainContainer">
					<img className="banner" src={loginBanner} />
					<div className="sectionContainer">
						<div className="headline containerMaxWidth">
							<h2>{ this.state.title }</h2>
						</div>
						<div className="bodyContent containerMaxWidth memberContainer">
							<p className="subHeader">Please sign in to view the content</p>
							<div className="inputBox">
								<span>Email address: </span>
								<input className="fieldInput" type="email" onChange={(e) => this.setState({ email: e.target.value }) } />
								<p className={this.state.errorEmail ? "errorRemark active" : "errorRemark"}>Please fill in a valid email address</p>
							</div>
							<div className="inputBox">
								<span>Password: </span>
								<input className="fieldInput" type="password" onChange={(e) => this.setState({ password: e.target.value }) } />
								<p className={this.state.errorPw ? "errorRemark active" : "errorRemark"}>Please fill in a valid password</p>
							</div>
							<div className="buttonBox">
								<div className="memberBtn actionBtn" onClick={() => this.validateLogin()}>
									<a><span>LOGIN</span></a>
								</div>
								<div className="memberBtn resetBtn actionBtn" onClick={() => this.resetPassword()}>
									<a><span>RESET PASSWORD</span></a>
								</div>
							</div>
							<p style={{ textAlign: 'center', position: 'relative' }} className={this.state.errorGeneral ? "errorRemark active" : "errorRemark"}>User does not exist</p>
							<p style={{ textAlign: 'center', position: 'relative' }} className={this.state.errorPending ? "errorRemark active" : "errorRemark"}>Account is under review</p>
							<p style={{ textAlign: 'center', position: 'relative' }} className={this.state.errorReset ? "errorRemark active" : "errorRemark"}>Reset password email has been sent to your email account</p>
						
							<div className="regRemark">
								<span>Do not have an account? Please click <a href="/register">here</a> to sign up.</span>
							</div>
						</div>
					</div>
				</div>
				<Footer urlKey={this.props.urlKey} />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(Login));